'use strict';
import {combineReducers} from 'redux';
import {createOrgRequest} from '../redux/createOrg';
import {CREATE_ORG_NAME, UPDATE_ORG_NAME} from '../redux/state';
import {updateOrgRequestModal} from '../redux/updateOrg';

export * from './state';

export const org = combineReducers({
  [CREATE_ORG_NAME]: createOrgRequest.reducers.reducer,
  [UPDATE_ORG_NAME]: updateOrgRequestModal.reducers.reducer,
});



// WEBPACK FOOTER //
// ./src/js/organizations/reducers/index.js